var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import Styles from './my-portfolio-overview-styles.scss';
import { ButtonKVBase, CircleLoader, DefaultModal } from '@/presentation/components';
import { IconActivity } from '@/presentation/components/icons';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { useNavigate } from 'react-router';
import PortfolioCardSmall from './components/porfolio-card-small';
import PortfolioCardBig from './components/portfolio-card-big/portfolio-card-big';
import RealEstateCard from './components/real-estate-card/real-estate-card';
import colors from '../../styles/colors.scss';
import { parseNumberMoney } from '@/presentation/utils/number-utils';
import PositionDetails from '../my-portfolio-brokerage/components/position-details/position-details';
import useValidateUserActivity from '@/presentation/hooks/use-validate-user-activity';
const MyPortfolioOverview = ({ manageApiStonk, manageUsers }) => {
    const [modalConfirm, setModalConfirm] = useState(false);
    const [purchaseList, setPurchaseList] = useState([]);
    const { user } = useUserSesssion();
    const [networth, setNetworth] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [listRealEstate, setListRealEstate] = useState([]);
    const { isAllowed, isLoading: isLoadingActivity } = useValidateUserActivity('STOCK_TRADING');
    const onGoStock = (e) => {
        setModalConfirm(false);
        navigate('/student-dashboard/activities/stock');
    };
    const navigate = useNavigate();
    const getNetwork = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield manageApiStonk.getNetwork(user === null || user === void 0 ? void 0 : user.id);
        if (response === null || response === void 0 ? void 0 : response.networth) {
            setNetworth(response === null || response === void 0 ? void 0 : response.networth);
        }
    });
    const getPurchasedStock = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield manageApiStonk.getPurchasedStock(user === null || user === void 0 ? void 0 : user.id);
        if ((response === null || response === void 0 ? void 0 : response.length) > 0) {
            setPurchaseList(response.map(item => {
                const customAmount = (item === null || item === void 0 ? void 0 : item.amount) || 0;
                const customQuantity = (item === null || item === void 0 ? void 0 : item.stockAmount) || 0;
                const customPrice = customAmount / customQuantity;
                return Object.assign(Object.assign({}, item), { customAmount, customQuantity, customPrice });
            }));
        }
        else {
            setPurchaseList([]);
        }
    });
    const getRealEstate = () => __awaiter(void 0, void 0, void 0, function* () {
        const studentRealEstate = yield manageUsers.studentFindRealEstate({ getConfig: '1' });
        if (studentRealEstate) {
            setListRealEstate(studentRealEstate);
        }
    });
    const initData = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        yield Promise.all([getNetwork(), getPurchasedStock(), getRealEstate()]);
        setIsLoading(false);
    });
    useEffect(() => {
        initData();
    }, []);
    const hasProperties = listRealEstate.length > 0;
    const totalMoneyEstate = listRealEstate.reduce((acc, item) => {
        var _a;
        return acc + (((_a = item === null || item === void 0 ? void 0 : item.equity) === null || _a === void 0 ? void 0 : _a.totalEquity) || 0);
    }, 0);
    return (React.createElement("div", { className: Styles.mainContainer },
        React.createElement("div", { style: {
                background: '#f3f3f9',
                display: 'flex',
                justifyContent: 'space-between',
                padding: '1rem 2rem',
                gridArea: 'header'
            } },
            React.createElement("h1", null, "My Portfolio"),
            React.createElement("div", null,
                React.createElement(ButtonKVBase, { onClick: () => setModalConfirm(true), type: "button", rightIcon: React.createElement(IconActivity, { color: "white" }), btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", disabled: !isAllowed || isLoadingActivity }, 'Start Trading'))),
        React.createElement(PortfolioCardSmall, { style: Styles.stocks, title: 'Stocks', text: 'Your Account Value', amount: parseNumberMoney(networth), onClick: () => navigate('/student-dashboard/my-portfolio/brokerage-account') }),
        React.createElement(PortfolioCardSmall, { style: Styles.realEstate, title: 'Real Estate Equity', text: 'Property you own', amount: parseNumberMoney(totalMoneyEstate), onClick: () => navigate('/student-dashboard/my-portfolio/real-estate') }),
        React.createElement("div", { className: Styles.lifetime }, isLoading ? (React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            } },
            React.createElement(CircleLoader, null))) : purchaseList.length === 0 ? (React.createElement(PortfolioCardBig, { title: 'My Top 3 Positions', subtitle: 'You have no stocks yet', subtext: 'Your selected position will appear here', setModalConfirm: setModalConfirm })) : (React.createElement(PositionDetails, { title: 'My Top 3 Positions', purchaseList: purchaseList, top3: true, setModalConfirm: setModalConfirm, onClickViewAll: () => navigate('/student-dashboard/my-portfolio/brokerage-account') }))),
        React.createElement("div", { className: Styles.daily }, isLoading ? (React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            } },
            React.createElement(CircleLoader, null))) : !hasProperties ? (React.createElement(PortfolioCardBig, { title: 'My Real Estate', subtitle: 'You have no real estate yet', subtext: 'Purchased real estate will appear here' })) : (React.createElement(RealEstateCard, { title: 'My Real Estate', onClickView: () => navigate('/student-dashboard/my-portfolio/real-estate'), listRealEstate: listRealEstate }))),
        React.createElement(DefaultModal, { height: "435", hUnit: "px", width: "512", wUnit: "px", open: modalConfirm, onClose: () => setModalConfirm(false), showClose: true, overlayCustomStyles: { zIndex: 9999 } },
            React.createElement("div", { className: Styles.modalContent },
                React.createElement("div", { className: Styles.icon },
                    React.createElement(IconActivity, { color: colors.invitedText, style: { width: 64, height: 64 } })),
                React.createElement("div", { className: Styles.title },
                    React.createElement("div", { className: Styles.main }, "It's time to trade!"),
                    React.createElement("div", { className: Styles.description }, 'Use what you have learned about the stock market to purchase your first three stocks.')),
                React.createElement(ButtonKVBase, { onClick: onGoStock, type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)" }, 'Start')))));
};
export default MyPortfolioOverview;
